import { render, staticRenderFns } from "./Archived.vue?vue&type=template&id=4b8ede46&scoped=true"
import script from "./Archived.vue?vue&type=script&lang=ts"
export * from "./Archived.vue?vue&type=script&lang=ts"
import style0 from "./Archived.vue?vue&type=style&index=0&id=4b8ede46&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8ede46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b8ede46')) {
      api.createRecord('4b8ede46', component.options)
    } else {
      api.reload('4b8ede46', component.options)
    }
    module.hot.accept("./Archived.vue?vue&type=template&id=4b8ede46&scoped=true", function () {
      api.rerender('4b8ede46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companyContractors/Archived.vue"
export default component.exports